/**
 * Mini modal que abre el botón "Crear nuevo" del header de Prospects.
 * Ofrece dos paths: manual (form vacío) o con IA (form pre-rellenado por
 * análisis web del prospect). Ambos redirigen a las rutas existentes
 * `/prospects/new` y `/prospects/new/ai` — no cambia el flow, solo unifica
 * el entry point en un solo botón.
 */
import { Plus, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { OptionCard } from '@/components/ui/option-card';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function NewProspectChoiceDialog({ open, onOpenChange }: Props) {
  const navigate = useNavigate();

  function go(path: string) {
    onOpenChange(false);
    navigate(path);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Crear nuevo prospect</DialogTitle>
          <DialogDescription>
            Elegí cómo arrancar. Después podés editar todo igual.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 flex flex-col gap-2.5">
          <OptionCard
            onSelect={() => go('/prospects/new/ai')}
            icon={<Sparkles className="size-4" />}
            title="Con IA"
            description="Sol analiza la web del prospecto y pre-rellena nombre, sector, dolor, oportunidad y propuesta."
            recommended
            selected
          />
          <OptionCard
            onSelect={() => go('/prospects/new')}
            icon={<Plus className="size-4" />}
            title="Manual"
            description="Form vacío. Vos cargás los campos uno por uno. Sirve si la IA no encuentra info o querés total control."
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
